module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-mobile-menu"
  }, [_vm._m(0), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li",
      "title": "5 Notificaitons",
      "icon": "ti-bell"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "ti-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v("\n        Notifications\n        "), _c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Another notification")])])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle btn-magnify",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "ti-panel"
  }), _vm._v(" "), _c('p', [_vm._v("Stats")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('p', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v("\n        Settings\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b1a4b54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/MobileMenu.vue
// module id = 509
// module chunks = 55